
import React, { useState } from 'react';
import { FAQItem } from '../types';
import { ChevronDown } from 'lucide-react';

const faqData: FAQItem[] = [
  {
    question: "Do I need to post on my own social media accounts?",
    answer: "No. Creators submit fully edited content directly to us. All posting, distribution, and community management is handled by our team on our official brand accounts."
  },
  {
    question: "Is there a max payout?",
    answer: "Yes. Performance bonuses are capped at $300 per video. This is in addition to your guaranteed monthly base pay."
  },
  {
    question: "How do I get paid?",
    answer: "You receive a monthly base pay plus performance bonuses based on how your submissions perform on our official channels. We process payments via direct bank transfer."
  },
  {
    question: "When do I get paid?",
    answer: "Payments are made on the first Monday of each month for the previous month's work. Your first month is pro-rated based on when you start. We tally up your base pay plus any performance bonuses from video views on our official accounts."
  },
  {
    question: "Do I need a large following?",
    answer: "No. We distribute the content ourselves. Since you aren't posting on your own account, your personal follower count does not matter. We only care about content quality."
  }
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-16">Questions, answered!</h2>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="border border-gray-100 rounded-2xl overflow-hidden hover:border-purple-200 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex justify-between items-center p-6 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg font-bold text-gray-900">{item.question}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="p-6 pt-0 text-gray-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
